<div>
    <mat-tab-group (selectedTabChange)="setSelectedTab($event)" [selectedIndex]="selectedTab">
        <mat-tab *kienePermission="[3851]" label="Bestandsbesuchsprotokoll">
            <ng-template matTabContent>
                <kiene-bestandsbesuchsprotokoll></kiene-bestandsbesuchsprotokoll>
            </ng-template>
        </mat-tab>

        <mat-tab *kienePermission="[9311]" [label]="'Tierwohlprotokoll Rind'">
            <ng-template matTabContent>
                <kiene-tierwohlprotokoll-rind></kiene-tierwohlprotokoll-rind>
            </ng-template>
        </mat-tab>

        <mat-tab *kienePermission="[9311]" [label]="'Tierwohlprotokoll Schwein'">
            <ng-template matTabContent>
                <kiene-tierwohlprotokoll-schwein></kiene-tierwohlprotokoll-schwein>
            </ng-template>
        </mat-tab>

        <mat-tab *kienePermission="[11000]" [label]="'Biosicherheitsplan Schwein'" [disabled]="disableBiosicherheitsplanSchweinTab">
            <ng-template matTabContent>
                <kiene-bio-sicherheitsplan-uebersicht></kiene-bio-sicherheitsplan-uebersicht>
            </ng-template>
        </mat-tab>

        <mat-tab *kienePermission="[11000]" [label]="'Evaluationsbögen Schwein'" [disabled]="disableBiosicherheitsplanSchweinTab">
            <ng-template matTabContent>
                <kiene-evaluationsbogen-schwein-uebersicht></kiene-evaluationsbogen-schwein-uebersicht>
            </ng-template>
        </mat-tab>

        <mat-tab *kienePermission="[110020]" [label]="'Biosicherheitsplan Rind'" [disabled]="disableBiosicherheitsplanRindTab">
            <ng-template matTabContent>
                <kiene-bio-sicherheits-plan-rind-uebersicht></kiene-bio-sicherheits-plan-rind-uebersicht>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
